import logo from './logo.svg';
import './App.css';
import { CONTEXTS } from 'figshelf-modules';
import React, { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/auth/Login';
import Main from './pages/main/Main';
import UserManagement from './pages/main/UserManagement';
import AdminManagement from './pages/main/AdminManagement';
import ModeratorManagement from './pages/main/ModeratorManagement';
import ModeratorControls from './pages/main/ModeratorControls';
import Reports from './pages/main/Reports';
import PremiumFeatures from './pages/main/PremiumFeatures';
import DiscountCodes from './pages/main/DiscountCodes';
import PremiumSubscribers from './pages/main/PremiumSubscribers';
import PaymentRequests from './pages/main/PaymentRequests';
import Settings from './pages/main/Settings';
import Database from './pages/main/Database';
import Profile from './pages/main/Profile';
import WikiArticleApproval from './pages/main/WikiArticleApproval';
import CompanyManagement from './pages/main/CompanyManagement';
import GroupManagement from './pages/main/GroupManagement';
import FigureManagement from './pages/main/FigureManagement';
import FigureDatabaseManagement from './pages/main/FigureDatabaseManagement';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  // Destructure the providers from CONTEXTS
  const { APIProvider, AuthProvider, ThemeProvider } = CONTEXTS;

  useEffect(() => {
    // ... existing code ...
  }, []);

  return (
    <React.StrictMode>
      <APIProvider>
        <AuthProvider>
          <ThemeProvider>
            <CssBaseline />
            <BrowserRouter>
              <Routes>
                {/* Protected routes - require authentication */}
                <Route 
                  path="/" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <Main />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/user-management" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <UserManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin-management" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <AdminManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/moderator-management" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <ModeratorManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/moderator-controls" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <ModeratorControls />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/company-management" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <CompanyManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/group-management" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <GroupManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/figure-management" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <FigureManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/figure-database-management" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <FigureDatabaseManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/reports" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <Reports />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/premium-features" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <PremiumFeatures />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/discount-codes" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <DiscountCodes />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/premium-subscribers" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <PremiumSubscribers />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/payment-requests" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <PaymentRequests />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/settings" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <Settings />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/database" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <Database />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <Profile />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/wiki-approval" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <WikiArticleApproval />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Public routes - redirect to home if already authenticated */}
                <Route 
                  path="/login" 
                  element={
                    <ProtectedRoute requireAuth={false}>
                      <Login />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Catch all route - redirect to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </ThemeProvider>
        </AuthProvider>
      </APIProvider>
    </React.StrictMode>
  );
}

export default App;
